<app-header></app-header>

<div class="container text-center bg-white rounded-md shadow-md p-8 mt-4">
  <h1 class="m-auto primary">404</h1>
  <p class="m-auto">Diese Seite wurde nicht gefunden!</p>
</div>

<app-footer></app-footer>
